export default __webpack_public_path__ + "static/media/logo_verify.ddd6d85c.png";